<template>
  <v-select
    solo
    outlined
    flat
    class="focus-input"
    hide-details="false"
    height="44px"
    auto-select-first="true"
    :value="value"
    :items="items"
    item-text="text"
    item-value="value"
    return-object
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  name: 'AdminStatusSelect',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
